import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const portalApi = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

// Response interceptor for portal-specific auth handling
portalApi.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    // If 401 and not already retrying, try refreshing the portal token.
    // Skip if the failing request IS the refresh call to avoid infinite loop.
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url?.includes('/portal/auth/refresh')
    ) {
      originalRequest._retry = true;

      try {
        await portalApi.post('/portal/auth/refresh');
        return portalApi(originalRequest);
      } catch (refreshError) {
        // Refresh failed — let the React auth layer handle the redirect
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export const portalAuthService = {
  login: (credentials) => portalApi.post('/portal/auth/login', credentials),
  logout: () => portalApi.post('/portal/auth/logout'),
  refresh: () => portalApi.post('/portal/auth/refresh'),
  getMe: () => portalApi.get('/portal/auth/me'),
  validateInvitation: (token) => portalApi.get(`/portal/auth/validate-invitation/${token}`),
  acceptInvitation: (data) => portalApi.post('/portal/auth/accept-invitation', data),
  requestPasswordReset: (email) => portalApi.post('/portal/auth/request-password-reset', { email }),
  resetPassword: (data) => portalApi.post('/portal/auth/reset-password', data),
};

export default portalApi;
